import { useState, useEffect, createContext, createElement, useContext, } from 'react';
var UserContext = createContext([null, function () { }]);
export var UserProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), user = _b[0], setUser = _b[1];
    useEffect(function () {
        var onError = function (e) {
            var _a;
            if (((_a = e.reason) === null || _a === void 0 ? void 0 : _a.type) === 'ClaraNotAuthenticated') {
                setUser(null);
                e.preventDefault();
                e.stopPropagation();
            }
        };
        window.addEventListener('unhandledrejection', onError);
        return function () {
            window.removeEventListener('unhandledrejection', onError);
        };
    }, []);
    return createElement(UserContext.Provider, {
        value: [user, setUser],
        children: children,
    });
};
export var useUserContext = function () {
    return useContext(UserContext);
};
export var useUserIfAvailable = function () {
    var user = useUserContext()[0];
    return user;
};
export function useUser() {
    var user = useUserIfAvailable();
    if (!user) {
        throw new Error('Expected user');
    }
    return user;
}
//# sourceMappingURL=UserContext.js.map